import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { ENVIRONMENT } from 'projects/dialog/src/app/core/models/environment.token';
import { EnvironmentInterface } from 'projects/dialog/src/app/core/models/environment.interface';
import { AuthStoreService } from 'projects/dialog/src/app/core/auth/auth-store.service';

@Component({
  selector: 'dl-disclaimer-dailog',
  templateUrl: './disclaimer-dailog.component.html',
  styleUrls: ['./disclaimer-dailog.component.scss']
})
export class DisclaimerDailogComponent implements OnInit {

  constructor(public router: Router, @Inject(ENVIRONMENT) private environment: EnvironmentInterface, private authStoreService: AuthStoreService) { }

  ngOnInit(): void {

  }
  public isAccepted(): void {
    this.router.navigateByUrl('/notification');
    localStorage.setItem('confidentialAgreed', 'true');
  }
  public isLogoff(): void {
    this.authStoreService.signOut().then(_ => window.location.href = `${window.location.origin}/logout`);
    localStorage.setItem('confidentialAgreed', 'false');
  }

}
